import React from 'react'
import CustomersOverview from '../../compositions/CustomersOverview'

const Customers: React.FC = () => {
    return (
        <div>
            <CustomersOverview />
        </div>
    )
}

export default Customers
